import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const IdPrecioListaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [precioListaItems, setPrecioListaItems] = React.useState([])

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.LISTAPRECIO).then(({ data }) => {
      setPrecioListaItems(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='LISTA PRECIO' htmlFor='select-idListaPrecio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idListaPrecio'>
          {({ field }) => (
            <Form.Select {...field} isInvalid={iTouched && iError} disabled={fIsSubmitting} id='select-idListaPrecio'>
              <option value=''>Todos</option>
              {precioListaItems.map((x, k) => (
                <option key={k} value={x._id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdPrecioListaFormGroup)
